import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import Select, { ActionMeta, components } from "react-select";
import SwitchSelector from "react-switch-selector";
import { Flex, Heading, Text, Image, Box, Button } from "rebass/styled-components";
import { Skeleton } from "../components/loadingSkeleton/Skeleton";
import PleaseWait from "../components/PleaseWait";
import { RbCircledChecked, RbCircledUnchecked } from "../components/RadioButton";
import { GET_CARE_TEAM_CONVERSATION_ID, GET_PATIENT_BY_ID, GET_PATIENT_CHART_ALERTS, GET_PATIENT_PHYSICIAN_CONVERSATION_ID } from "../graphql/queries";
import { IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput, IGetProviderPatientChartAlertInput, IGetProviderPatientChartAlertOutput } from "../graphql/types/queries/patient";
import { ReactSelectStyles } from "../styles/ReactSelectStyles";
import { Constants } from "../utils/Constants";
import { Appointments } from "./patient/Appointments";
import { CareLocations } from "./patient/CareLocations";
import { Charts } from "./patient/Charts";
import Labs from "./patient/Labs";
import { LastCourses } from "./patient/LastCourses";
import { ProfileCard } from "./patient/ProfileCard";
import { Quickview } from "./patient/Quickview";
import KeyInfos from './patient/KeyInfos'
import { Symptoms } from "./patient/Symptoms";
import doctorIcon from '../static/logoloader2.gif';
import { LoadingMessages } from "../components/icons/LoadingMessages";
import { getMockedFirstName, getMockedLastName } from "../utils/mocks";
import LabsList from "./patient/LabsList";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { useRef } from "react";
import { sleep } from "../utils/sleep";
import { SurveyChart } from "./surveys/SurveyChart";
import { Surveys } from "./patient/Surveys";
import { PatientCases } from "./patient/PatientCases";
import Modal from "styled-react-modal";
import { SpecialModalBackground } from "../components/Commons";
import ViewHpis from "./patient/ViewHpis";
import { Form, Formik } from "formik";
import FormField from "../components/FormField";
import TextArea from "../components/TextArea";
import LabsAndVisits from "./patient/LabsAndVisits";
import { IAppendChartAlertInput, IAppendChartAlertOutput } from "../graphql/types/mutations/patient";
import { APPEND_CHART_ALERT } from "../graphql/mutations";
import CommunicatorMessagerEmbedded from "./messages/components/CommunicatorMessagerEmbedded";
import { IGetCareTeamConversationIdOutput, IGetCareTeamConversationIdInput, IProviderGetUserPhysicianConversationsTreeOutput, IProviderGetUserPhysicianConversationsTreeInput } from "../graphql/types/queries/conversation";
import { PatientNotFoundSvg } from "./patient/components/PatientNotFoundSvg";
import HpisWrapper from "./patient/HpisWrapper";
import { PatientsPhoto } from "./patient/components/PatientsPhoto";
// import SymptomsAndAppointments from "./patient/SymptomsAndAppointments";

const Wrapper = styled(Flex)`
  overflow: auto;
  width: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
const Container = styled(Flex)`
  padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  padding-bottom: 0;
  max-width: 100%;
  max-height: 100vh;
  height: 100vh;
  overflow: hidden;
  @media screen and (min-width: 68.8125em) {
  padding-left: 16px;
  padding-top: 16px;
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  max-width: initial;
  height: 100vh;
  /* padding-bottom: 0; */
  }
`

const MessagesWrap = styled(Flex) <{ isExpanded: boolean }>`
transition: all 150ms ease-in;
max-width: 500px;
justifify-content: flex-end;
@media screen and (max-width: 1600px) {
position: ${(props) => props.isExpanded ? 'absolute' : 'static'};
top:0;
 right: 0;
 z-index: 10;
}

`

const MessagesWrapBox = styled(Flex)`
transition: all 50ms ease-in;
`

const LoaderSvg = styled.svg`
@media screen and (min-width: 68.8125em) {
padding: ${() => `${Constants.OUTLETS_PADDING}px`};
padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
max-width: initial;
/* padding-bottom: 0; */
}
  
`

const TabsContainer = styled(Flex)`
  background: transparent;
  margin-left: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  margin-right: ${() => `-${Constants.OUTLETS_PADDING_MOBILE}px`};
  padding: ${() => `3px ${Constants.OUTLETS_PADDING_MOBILE}px`};
  height: 50px;
  min-height: 80px;
  overflow-x: auto;
  text-align: center;
  @media screen and (min-width: 68.8125em) {
  border: 1px solid #e0e0e0;
  margin-left: 0;
  margin-right: 0;
  border-radius: 16px;
  /* padding: 3px 6px; */
overflow-x: hidden;
  min-height: 50px;
  }
`
export interface IOptionsDaysBack {
  value: number;
  label: string;
}
const optionsDaysBack: Array<IOptionsDaysBack> = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 365, label: 'Last year' },
]
const optionsView = [
  {
    label: 'Labs & visits',
    value: 'Labs',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
  {
    label: 'Key Info',
    value: 'keyInfos',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
  {
    label: "Surveys",
    value: "surveys",
    selectedBackgroundColor: "#344F7A"
  },
  {
    label: "Courses",
    value: "courses",
    selectedBackgroundColor: "#344F7A"
  },
  {
    label: 'Symptoms',
    value: 'symptoms',
    selectedBackgroundColor: "#344F7A",
    disabled: true
  },
  // {
  //   label: "Quickview",
  //   value: "quickview",
  //   selectedBackgroundColor: "#344F7A"
  // },
  // {
  //   label: "Patient Cases",
  //   value: "cases",
  //   selectedBackgroundColor: "#344F7A"
  // },
  // {
  //   label: "Intake",
  //   value: "charts",
  //   selectedBackgroundColor: "#344F7A"
  // },
  // {
  //   label: "Care Locations",
  //   value: "locations",
  //   selectedBackgroundColor: "#344F7A"
  // },
];

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

export const CommunicatorEmbedding: React.FC<{
  athenaId: string,
  helpscoutId: string
  isHpiEmbed?:boolean
}> = ({ athenaId, helpscoutId, isHpiEmbed }) => {
  const { data, loading, error } = useQuery<IProviderGetUserPhysicianConversationsTreeOutput, IProviderGetUserPhysicianConversationsTreeInput>(GET_PATIENT_PHYSICIAN_CONVERSATION_ID, {
    variables: {
      userId: athenaId
    }
  })
  const { data: dataCareTeam, loading: loadingCareTeam } = useQuery<IGetCareTeamConversationIdOutput, IGetCareTeamConversationIdInput>(GET_CARE_TEAM_CONVERSATION_ID, {
    variables: {
      helpscoutId
    }
  })

  if (!!loading || !!loadingCareTeam) {
    return (
      <Box style={{ height: '100%', background: '#C0CDEC', flex: 1, borderRadius: '20px', paddingTop: '20px', maxWidth: '460px', minWidth: '460px', width: '460px' }}>
        <Flex flex={1} marginTop={4} width='100%' height='100%' flexDirection={'column'} justifyContent='center' alignItems={'center'} >
          <LoadingMessages style={{ maxWidth: '50%' }} />
        </Flex>
      </Box>)
  }
  //"1436980675"
  return (
    <CommunicatorMessagerEmbedded isHpiEmbed={isHpiEmbed} athenaId={athenaId} conversationId={data?.providerGetUserPhysicianConversationsTree} careTeamConvoId={dataCareTeam?.healthCoachGetCareTeamConversationId}/>
  )
}
export const PatientInner = ({ id }: { id: string }) => {

  const chartAlertRef = useRef<any>(null)
  const { data, loading, error, refetch: refetchChartAlerts } = useQuery<IGetProviderPatientChartAlertOutput, IGetProviderPatientChartAlertInput>(GET_PATIENT_CHART_ALERTS, {
    variables: {
      id
    },
    onCompleted: async () => {
      await sleep(300)
      ReactTooltip.rebuild()

      ReactTooltip.show(chartAlertRef.current)
    }
  })
  const [isExpanded, setisExpanded] = useState<boolean>(false);
  const [isViewHpis, setIsViewHpis] = useState(false)
  const [selectedView, setselectedView] = useState<'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys'>('Labs');
  const [selectedPeriod, setSelectedPeriod] = useState<IOptionsDaysBack>(optionsDaysBack.find(x => x.value === 7)!)
  const [isEditAlert, setIsEditAlert] = useState(false)
  const [appendChartAlert, { loading: loadingAppendChartAlert }] = useMutation<IAppendChartAlertOutput, IAppendChartAlertInput>(APPEND_CHART_ALERT)

  const [loadPatient, { data: dataPatient, loading: loadingPatient, error: errorPatient }] = useLazyQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID)

  useEffect(() => {
    if (!id) return
    loadPatient({
      variables: {
        id
      }
    })
  }, [id])

  useEffect(() => {

    ReactTooltip.rebuild();
    if (data && data.getProviderPatientChartAlert) {
      ReactTooltip.show(chartAlertRef.current)
    }
  }, [data, dataPatient])
  const toggleExpanded = () => {
    setisExpanded(!isExpanded)
  }
  if (!id) return null
  if (loadingPatient) return (
    <Container flexDirection={'column'} style={{ height: '100%' }}>
      <Flex mb={4} alignItems='center'>
        <Box display={['none!important', 'flex', 'flex']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
        </svg></Box>
        <Skeleton height={36} width={250} style={{ marginLeft: '12px' }} />
      </Flex>
      <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <LoadingMessages style={{ maxWidth: '50%' }} />
      </Flex>
    </Container>
  )
  if (!dataPatient || !dataPatient.getProviderPatientById) {
    return (<Container flexDirection={'column'}
      justifyContent='center'
      alignItems={'center'}
      id='contPatient'
      style={{ height: '100%' }}>
      <Flex style={{ position: 'relative' }}>
        <Flex style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Image src={doctorIcon} style={{ marginTop: '-180px', opacity: 0.5, marginRight: '-100px' }} width='80px' height='80px' />
        </Flex>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 500 500"
          width={997}
          height={653}
          className="empty"
        >
          <g
            className="empty_svg__animable empty_svg__animator-active"
            style={{
              transformOrigin: "227.87px 256.639px",
            }}
          >
            <path
              d="M130.36 194.26c-.88 2-1.85 4.16-2.7 6.27s-1.73 4.28-2.5 6.44a91.35 91.35 0 0 0-3.79 12.93l-.29 1.6-.1.6c0 .17 0 .39-.06.59a24.53 24.53 0 0 0 .06 2.92c.19 2.11.53 4.37 1 6.63.84 4.53 1.91 9.2 3 13.8l-5.13 2a92.65 92.65 0 0 1-6.09-13.59 57 57 0 0 1-2.12-7.47 26.81 26.81 0 0 1-.56-4.26v-1.21c0-.43 0-.91.07-1.19l.2-2a63 63 0 0 1 1.37-7.65c.56-2.5 1.28-4.93 2-7.33s1.62-4.76 2.57-7.08c.47-1.16 1-2.31 1.46-3.46s1-2.25 1.64-3.48z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "120.72px 218.68px",
              }}
            />
            <path
              d="m124.71 244.69 3.9 3.81-8.51 4s-2.06-3.61-.63-6.87z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "123.787px 248.595px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="m131.76 254.17-7.19 2.94-4.46-4.65 8.5-3.96 3.15 5.67z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "125.935px 252.805px",
              }}
            />
            <path
              d="M277.41 250.07A72 72 0 1 1 357 186.5a72 72 0 0 1-79.59 63.57z"
              fill="#fafafa"
              opacity={0.4}
              className="empty_svg__animable"
              style={{
                transformOrigin: "285.444px 178.52px",
              }}
            />
            <path
              d="m329.79 121.79-109.5 87.49c-.46-1-.91-2-1.33-3a71.24 71.24 0 0 1-5.21-20.48l94.58-75.57a71.15 71.15 0 0 1 21.46 11.56z"
              fill="#fafafa"
              opacity={0.4}
              className="empty_svg__animable"
              style={{
                transformOrigin: "271.77px 159.755px",
              }}
            />
            <path
              d="m355.06 160.12-102.95 82.25a71.86 71.86 0 0 1-24.77-21.28l112.41-89.82a72 72 0 0 1 15.31 28.85z"
              fill="#fafafa"
              opacity={0.4}
              className="empty_svg__animable"
              style={{
                transformOrigin: "291.2px 186.82px",
              }}
            />
            <path
              d="m204.39 151-.95-.32a87.68 87.68 0 0 1 6.18-14.05l.87.48a86.93 86.93 0 0 0-6.1 13.89zm12.14-23.34-.81-.59a86.7 86.7 0 0 1 31.37-26.21l.45.9a85.74 85.74 0 0 0-31.01 25.93zm109.59-24.53A83.6 83.6 0 0 0 316 98.54l.36-.94a85.62 85.62 0 0 1 10.22 4.68z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "265.01px 124.3px",
              }}
            />
            <path
              d="m204.39 151-.95-.32a87.68 87.68 0 0 1 6.18-14.05l.87.48a86.93 86.93 0 0 0-6.1 13.89zm12.14-23.34-.81-.59a86.7 86.7 0 0 1 31.37-26.21l.45.9a85.74 85.74 0 0 0-31.01 25.93zm109.59-24.53A83.6 83.6 0 0 0 316 98.54l.36-.94a85.62 85.62 0 0 1 10.22 4.68z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "265.01px 124.3px",
              }}
            />
            <path
              d="M359.87 141.74a83 83 0 0 0-152.65 64.73c-6.68 2.34-13.28 4.85-19.84 7.44q-14.19 5.63-28.12 11.76c-9.28 4.11-18.52 8.3-27.67 12.68-4.59 2.15-9.12 4.42-13.69 6.62a19.79 19.79 0 0 0-6.34 4.35 19.15 19.15 0 0 0-2.57 3.37 17.25 17.25 0 0 0-2 4.63 12.72 12.72 0 0 0 7.33 14.85 17.56 17.56 0 0 0 4.86 1.26 18.88 18.88 0 0 0 4.25 0 19.76 19.76 0 0 0 7.3-2.39c4.53-2.29 9.09-4.5 13.59-6.85 9-4.59 18-9.38 26.89-14.24S189 240 197.68 234.78c6-3.63 12.06-7.34 18-11.22a83 83 0 0 0 144.21-81.82zm-45.46 95.53a65.53 65.53 0 1 1 29.75-87.78 65.53 65.53 0 0 1-29.75 87.78z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "237.695px 184.169px",
              }}
            />
            <path
              d="M359.87 141.74a83 83 0 0 0-152.65 64.73c-6.68 2.34-13.28 4.85-19.84 7.44q-14.19 5.63-28.12 11.76c-9.28 4.11-18.52 8.3-27.67 12.68-4.59 2.15-9.12 4.42-13.69 6.62a19.79 19.79 0 0 0-6.34 4.35 19.15 19.15 0 0 0-2.57 3.37 17.25 17.25 0 0 0-2 4.63 12.72 12.72 0 0 0 7.33 14.85 17.56 17.56 0 0 0 4.86 1.26 18.88 18.88 0 0 0 4.25 0 19.76 19.76 0 0 0 7.3-2.39c4.53-2.29 9.09-4.5 13.59-6.85 9-4.59 18-9.38 26.89-14.24S189 240 197.68 234.78c6-3.63 12.06-7.34 18-11.22a83 83 0 0 0 144.21-81.82zm-45.46 95.53a65.53 65.53 0 1 1 29.75-87.78 65.53 65.53 0 0 1-29.75 87.78z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "237.695px 184.169px",
              }}
            />
            <path
              d="M158 158.55c0 .59.31 1.07.7 1.07s.7-.48.7-1.07-.31-1.07-.7-1.07-.7.52-.7 1.07z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "158.7px 158.55px",
              }}
            />
            <path
              d="M158.28 159.62a21.33 21.33 0 0 0 2.83 5.07 3.41 3.41 0 0 1-2.83.53z"
              fill="#de5753"
              className="empty_svg__animable"
              style={{
                transformOrigin: "159.695px 162.473px",
              }}
            />
            <path
              d="M155.93 155.26a.37.37 0 0 1-.29-.14.36.36 0 0 1 .08-.49 3.43 3.43 0 0 1 3.13-.53.35.35 0 1 1-.25.65 2.73 2.73 0 0 0-2.47.45.36.36 0 0 1-.2.06z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "157.343px 154.596px",
              }}
            />
            <path
              d="M137.8 163c1 5.37 2.1 15.22-1.66 18.81 0 0 1.47 5.45 11.46 5.45 11 0 5.24-5.45 5.24-5.45-6-1.44-5.83-5.88-4.79-10.06z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "145.244px 175.13px",
              }}
            />
            <path
              d="M131.65 184.64c1.19-1.85-.81-6.34-.81-6.34s17.68-4.45 24.91 2.38c1.5 1.41-.16 3.49-.16 3.49z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "143.609px 180.758px",
              }}
            />
            <path
              d="M131.65 184.64c1.19-1.85-.81-6.34-.81-6.34s17.68-4.45 24.91 2.38c1.5 1.41-.16 3.49-.16 3.49z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "143.609px 180.758px",
              }}
            />
            <path
              d="M102.4 388.67c-.93 0-2.42-1.55-2.86-2.13a.17.17 0 0 1 0-.19.18.18 0 0 1 .16-.09c.11 0 2.56.22 3.23 1.09a.81.81 0 0 1 .16.66.72.72 0 0 1-.52.65zm-2.32-2c.73.84 1.9 1.79 2.4 1.67 0 0 .2-.05.26-.37a.45.45 0 0 0-.1-.38 4.67 4.67 0 0 0-2.56-.94z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "101.308px 387.465px",
              }}
            />
            <path
              d="M100.19 386.65a2.68 2.68 0 0 1-.54 0 .16.16 0 0 1-.14-.11.2.2 0 0 1 0-.18c.07-.06 1.54-1.59 2.65-1.59a.94.94 0 0 1 .71.3.57.57 0 0 1 .14.7c-.29.56-1.82.88-2.82.88zm-.13-.35c1 0 2.45-.31 2.69-.75 0 0 .07-.13-.09-.29a.59.59 0 0 0-.46-.19 4.23 4.23 0 0 0-2.14 1.23z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "101.281px 385.717px",
              }}
            />
            <path
              d="M168.39 411.37a13.25 13.25 0 0 1-2.26-.21.16.16 0 0 1-.13-.16.18.18 0 0 1 .08-.18c.11-.06 2.67-1.53 3.9-1.19a.86.86 0 0 1 .55.4.66.66 0 0 1 0 .76c-.29.45-1.2.58-2.14.58zm-1.69-.47c1.36.2 3.22.19 3.56-.29.05-.06.09-.17 0-.38a.56.56 0 0 0-.34-.25c-.78-.2-2.33.46-3.22.92z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "168.324px 410.475px",
              }}
            />
            <path
              d="M166.17 411.17a.18.18 0 0 1-.1 0 .16.16 0 0 1-.07-.17 4.88 4.88 0 0 1 1.14-2.83 1.25 1.25 0 0 1 1-.29c.48 0 .62.29.65.48.13.83-1.62 2.42-2.51 2.82zm1.79-3a.91.91 0 0 0-.6.22 4 4 0 0 0-1 2.27c.9-.55 2.1-1.79 2-2.29 0 0 0-.17-.34-.2z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "167.396px 409.523px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="M158.09 410.99h7.35l.73-17.01h-7.35l-.73 17.01z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "162.13px 402.485px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="m92.64 381.79 6.14 4.02 13.56-11.45-6.15-4.03-13.55 11.46z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "102.49px 378.07px",
              }}
            />
            <path
              d="m99.79 385.43-6.38-5.23a.63.63 0 0 0-.8 0l-5.26 4.13a1.08 1.08 0 0 0 0 1.69c2.26 1.79 3.45 2.55 6.26 4.85 1.73 1.41 6 5.73 8.41 7.68s4.62-.15 3.82-1.16c-3.59-4.55-5-8.44-5.41-10.85a1.81 1.81 0 0 0-.64-1.11z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "96.4747px 389.704px",
              }}
            />
            <path
              d="M165.39 410.14h-8a.65.65 0 0 0-.63.5l-1.45 6.53a1.07 1.07 0 0 0 1.06 1.31c2.89-.05 7.07-.22 10.71-.22 4.25 0 7.93.23 12.91.23 3 0 3.86-3.05 2.59-3.32-5.74-1.26-10.44-1.39-15.4-4.46a3.44 3.44 0 0 0-1.79-.57z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "169.215px 414.315px",
              }}
            />
            <path
              d="M121.66 184c-6.37 3-10 23.1-10 23.1l15.57 6.21a115.83 115.83 0 0 0 5.51-17.15c2.14-9.26-4.56-15.26-11.08-12.16z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "122.403px 198.243px",
              }}
            />
            <path
              d="M129.92 195.33c-3.85 3.9-5.61 11.54-6.38 16.51l3.73 1.49a116.7 116.7 0 0 0 5.4-16.65c-.33-2.12-1.15-2.97-2.75-1.35z"
              fill="#203048"
              className="empty_svg__animable"
              style={{
                transformOrigin: "128.105px 203.907px",
              }}
            />
            <path
              d="M164.14 183.86s7.82 8.84.44 63.5h-39.29c-.27-6 3.52-35.45-2.3-63.87a100.56 100.56 0 0 1 13.15-1.66 140.87 140.87 0 0 1 16.7 0 74.19 74.19 0 0 1 11.3 2.03z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "145.37px 214.471px",
              }}
            />
            <path
              d="m167.73 205.08-6.62-11.41a58.31 58.31 0 0 0-1.55 16.27c.18 3.92 3.77 18.44 7 20.56a230.84 230.84 0 0 0 1.17-25.42z"
              fill="#203048"
              className="empty_svg__animable"
              style={{
                transformOrigin: "163.619px 212.085px",
              }}
            />
            <path
              d="M168.65 191.67c1 4.86 2 9.84 3.07 14.72s2.18 9.78 3.47 14.51c.33 1.17.64 2.37 1 3.49l.27.86.13.43v-.05c-.07-.09-.15-.1-.09 0a3.35 3.35 0 0 0 1.52.95 17.84 17.84 0 0 0 2.91.81 77.79 77.79 0 0 0 14.3.93l.95 5.44c-1.34.43-2.59.74-3.91 1.05s-2.62.57-3.95.77a42.73 42.73 0 0 1-8.33.56 22.61 22.61 0 0 1-4.6-.6 13.39 13.39 0 0 1-5.28-2.45 9.65 9.65 0 0 1-2.47-3c-.16-.3-.3-.64-.43-.93l-.18-.47-.37-1c-.51-1.27-.93-2.52-1.39-3.77-1.69-5-3.1-10.05-4.34-15.09s-2.31-10.07-3.2-15.24z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "176.955px 213.915px",
              }}
            />
            <path
              d="M154.33 189.22c-2.07 6.71 6.32 26.72 6.32 26.72l16.71-4.2s-.64-10.4-4.45-18.65c-5.74-12.44-16.1-11.92-18.58-3.87z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "165.681px 199.68px",
              }}
            />
            <path
              d="m195.09 228.32 8.32-.21-4 8.66s-3.39.45-6.17-4.12l-2.93-3.5 3.37-.67a7.52 7.52 0 0 1 1.41-.16z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "196.86px 232.446px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="m208.66 229.72-4.76 7.18-4.49-.13 4-8.66 5.25 1.61z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "204.035px 232.505px",
              }}
            />
            <path
              fill="#ce6f64"
              d="m166.17 393.98-.38 8.77h-7.35l.38-8.77h7.35z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "162.305px 398.365px",
              }}
            />
            <path
              fill="#ce6f64"
              d="m106.19 370.33 6.15 4.03-7 5.9-6.14-4.02 6.99-5.91z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "105.77px 375.295px",
              }}
            />
            <path
              d="M138.26 157.28c.44 7.27.33 11.56 4 15.29 5.52 5.63 14.51 2.3 16.25-5 1.57-6.54.59-17.34-6.53-20.24a10 10 0 0 0-13.72 9.95z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "148.696px 161.003px",
              }}
            />
            <path
              d="M129.7 156c1.81 6.63 6.07 14.27 11.58 14.76 6.84.6 9.93-6.47 10.83-13.77 4.1-2.81 1.95-5.9 6.06-6.29 5.28-.5 3.59-10.16-3.36-11.71 0 0 2.33 4.35-2.56 2.15a28.22 28.22 0 0 0-14.94-2.59s6.24 3.12.14 4.51-7.92 5.15-5.11 7.42c0 .01-3.83 1.16-2.64 5.52z"
              fill="#263238"
              className="empty_svg__animable"
              style={{
                transformOrigin: "145.37px 154.602px",
              }}
            />
            <path
              d="M147.94 158.49a8.22 8.22 0 0 0 2.07 4.87c1.6 1.77 3.27.67 3.55-1.48.26-1.93-.27-5.18-2.23-6.16s-3.52.59-3.39 2.77z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "150.777px 159.832px",
              }}
            />
            <path
              d="M150.64 247.36s7.16 51.85 1.52 72.63c-8.94 32.9-43.12 60.67-43.12 60.67l-11.59-7.6s29.11-23.45 32.67-51c3.2-24.73-4.83-54.64-4.83-74.71z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "125.888px 314.005px",
              }}
            />
            <path
              d="M150.64 247.36s7.16 51.85 1.52 72.63c-8.94 32.9-43.12 60.67-43.12 60.67l-11.59-7.6s29.11-23.45 32.67-51c3.2-24.73-4.83-54.64-4.83-74.71z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "125.888px 314.005px",
              }}
            />
            <path
              d="M153.6 277a48.4 48.4 0 0 0-6.27-6c1.22 16.83 2.22 41.76 1.11 59.47a76.41 76.41 0 0 0 3.72-10.47c2.75-10.15 2.46-27.68 1.44-43z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "150.829px 300.735px",
              }}
            />
            <path
              d="M153.6 277a48.4 48.4 0 0 0-6.27-6c1.22 16.83 2.22 41.76 1.11 59.47a76.41 76.41 0 0 0 3.72-10.47c2.75-10.15 2.46-27.68 1.44-43z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "150.829px 300.735px",
              }}
            />
            <path
              d="M113.71 378.07c.05 0-4.49 3-4.49 3l-12.66-8.3 4-3.31z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "105.135px 375.265px",
              }}
            />
            <path
              d="M113.71 378.07c.05 0-4.49 3-4.49 3l-12.66-8.3 4-3.31z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "105.135px 375.265px",
              }}
            />
            <path
              d="M164.58 247.36s11.06 46.9 11.84 69.31c.88 25.12-7.89 84.38-7.89 84.38h-12.45s-1.53-59.72-2.08-82.6c-.61-24.95-15.25-71.09-15.25-71.09z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "157.616px 324.205px",
              }}
            />
            <path
              d="M164.58 247.36s11.06 46.9 11.84 69.31c.88 25.12-7.89 84.38-7.89 84.38h-12.45s-1.53-59.72-2.08-82.6c-.61-24.95-15.25-71.09-15.25-71.09z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "157.616px 324.205px",
              }}
            />
            <path
              d="M170.92 396.1c.06 0-.7 5.16-.7 5.16h-15.14l-.41-4.61z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "162.797px 398.68px",
              }}
            />
            <path
              d="M170.92 396.1c.06 0-.7 5.16-.7 5.16h-15.14l-.41-4.61z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "162.797px 398.68px",
              }}
            />
          </g>
          <g
            data-name="Character"
            className="empty_svg__animable"
            style={{
              transformOrigin: "337.551px 287.938px",
            }}
          >
            <path
              d="M356 202.29c.85.8 1.52 1.48 2.22 2.24s1.36 1.5 2 2.27c1.3 1.53 2.52 3.14 3.7 4.76a76.27 76.27 0 0 1 6.27 10.26l.37.73a7.05 7.05 0 0 1 .45 1.1 9.12 9.12 0 0 1 .44 2.26 11 11 0 0 1-.55 4 20.16 20.16 0 0 1-3.21 5.92 42.68 42.68 0 0 1-8.8 8.46l-2.49-2.86c1.17-1.37 2.39-2.84 3.48-4.31a36.76 36.76 0 0 0 3-4.5 15.63 15.63 0 0 0 1.82-4.42 4.58 4.58 0 0 0 .07-1.7 2.22 2.22 0 0 0-.18-.55 1.59 1.59 0 0 0-.13-.22l-.32-.54a105.06 105.06 0 0 0-6.27-9.11c-1.11-1.47-2.3-2.88-3.5-4.27-.59-.7-1.2-1.38-1.81-2.06s-1.27-1.36-1.8-1.89z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "361.111px 223.29px",
              }}
            />
            <path
              d="m357.36 240.59-7.47-1.22 3.91 6.54s4.81-.17 6.18-3z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "354.935px 242.64px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="m344.37 242.39 3.56 5.31 5.87-1.79-3.91-6.54-5.52 3.02z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "349.085px 243.535px",
              }}
            />
            <path
              d="M357 411.28a2.15 2.15 0 0 1-1.43-.39 1 1 0 0 1-.29-.94.59.59 0 0 1 .35-.5c.87-.39 3.15 1.07 3.41 1.24a.16.16 0 0 1 .07.18.16.16 0 0 1-.13.14 8.85 8.85 0 0 1-1.98.27zm-1-1.55a.72.72 0 0 0-.22 0 .26.26 0 0 0-.15.23.67.67 0 0 0 .18.63c.38.34 1.36.39 2.67.13a6.59 6.59 0 0 0-2.48-.99z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "357.187px 410.336px",
              }}
            />
            <path
              d="M359 411h-.09c-.71-.41-2.08-2-1.91-2.87a.65.65 0 0 1 .6-.5.9.9 0 0 1 .75.24c.82.72.83 2.88.83 3a.19.19 0 0 1-.09.15zm-1.28-3h-.08c-.22 0-.27.12-.29.21-.1.51.75 1.73 1.46 2.3a4.09 4.09 0 0 0-.69-2.36.57.57 0 0 0-.45-.15z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "358.083px 409.32px",
              }}
            />
            <path
              d="M322.92 411.28a2.77 2.77 0 0 1-1.81-.46 1 1 0 0 1-.33-.86.58.58 0 0 1 .3-.47c.93-.52 3.91 1 4.25 1.19a.2.2 0 0 1 .09.19.17.17 0 0 1-.14.14 12.47 12.47 0 0 1-2.36.27zm-1.33-1.55a.62.62 0 0 0-.33.07.21.21 0 0 0-.12.19.65.65 0 0 0 .2.57c.46.41 1.69.48 3.35.2a9.73 9.73 0 0 0-3.1-1.03z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "323.097px 410.337px",
              }}
            />
            <path
              d="M325.25 411h-.08c-.89-.4-2.66-2-2.52-2.87 0-.2.18-.45.67-.5a1.32 1.32 0 0 1 1 .31c.94.78 1.12 2.8 1.12 2.89a.17.17 0 0 1-.07.16.19.19 0 0 1-.12.01zm-1.79-3h-.11c-.32 0-.34.16-.35.2-.08.51 1.12 1.78 2 2.33a4.16 4.16 0 0 0-1-2.31.93.93 0 0 0-.54-.22z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "324.042px 409.314px",
              }}
            />
            <path
              d="M337.07 179.3c-.29 4.52-1.07 13.7 2.4 16.24 0 0-.63 4.63-8.82 5.71-9 1.17-4.89-3.91-4.89-3.91 4.77-1.82 4.16-5.45 2.86-8.77z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "332.147px 190.363px",
              }}
            />
            <path
              d="M318.44 171.31a.34.34 0 0 1-.26-.12 2.83 2.83 0 0 0-2.35-1 .35.35 0 0 1-.41-.3.36.36 0 0 1 .31-.4 3.51 3.51 0 0 1 3 1.26.36.36 0 0 1-.27.59z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "317.115px 170.409px",
              }}
            />
            <path
              d="M316.88 175.74a16.28 16.28 0 0 1-1.63 4.1 2.58 2.58 0 0 0 2.19.12z"
              fill="#de5753"
              className="empty_svg__animable"
              style={{
                transformOrigin: "316.345px 177.944px",
              }}
            />
            <path
              d="M317.28 174.64c.08.6-.17 1.12-.56 1.18s-.78-.4-.85-1 .17-1.12.56-1.17.78.35.85.99z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "316.576px 174.736px",
              }}
            />
            <path
              d="m316.61 173.66-1.49-.23s.88 1.03 1.49.23z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "315.865px 173.697px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="M333.49 410.84h-7.5l-.5-17.35h7.5l.5 17.35z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "329.49px 402.165px",
              }}
            />
            <path
              fill="rgb(248, 162, 148)"
              d="M367.54 410.84h-7.5l-2.41-17.35h7.5l2.41 17.35z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "362.585px 402.165px",
              }}
            />
            <path
              d="M359.58 410H368a.59.59 0 0 1 .59.51l1 6.67a1.2 1.2 0 0 1-1.2 1.33c-2.93-.05-4.35-.22-8.05-.22-2.28 0-5.61.23-8.75.23s-3.31-3.11-2-3.39c5.87-1.26 6.8-3 8.77-4.67a2 2 0 0 1 1.22-.46z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "359.208px 414.26px",
              }}
            />
            <path
              d="M325.74 410h8.41a.6.6 0 0 1 .6.51l1 6.67a1.2 1.2 0 0 1-1.2 1.33c-2.93-.05-4.35-.22-8.05-.22-2.28 0-7 .23-10.14.23s-3.31-3.11-2-3.39c5.87-1.26 8.18-3 10.16-4.67a2 2 0 0 1 1.22-.46z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "324.673px 414.26px",
              }}
            />
            <path
              fill="#ce6f64"
              d="m325.49 393.49.26 8.95h7.5l-.26-8.95h-7.5z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "329.37px 397.965px",
              }}
            />
            <path
              fill="#ce6f64"
              d="M365.13 393.49h-7.5l1.25 8.95h7.49l-1.24-8.95z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "362px 397.965px",
              }}
            />
            <path
              d="M337.17 169.94c.51 7.42.88 10.55-2.34 14.82-4.85 6.41-14.07 5.42-16.79-1.7-2.45-6.41-2.87-17.46 3.95-21.34a10.15 10.15 0 0 1 15.18 8.22z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "326.957px 174.705px",
              }}
            />
            <path
              d="M341.49 176.83c4.16 2.32 7.25-3.4 7.25-3.4s-7.46.81-6.79-3.63c.88-5.89-3.34-13.05-13.92-12.13-.59.05-1.15.12-1.7.21a5.44 5.44 0 0 0-6.58 1.52c-3 .25-7.05 3.83-4.3 8.56a4.35 4.35 0 0 1 .88-1.47c.23 2.77 2.65 7.17 5.67 7.46.65 3.79-1.87 8.18-1 12.14 1.29 5.71 10.92 7 10.92 7a4.17 4.17 0 0 1 .56-4.41c6.54 3 10.85.07 10.85.07-4.46-1.66-3.11-4.62-3.11-4.62a6.51 6.51 0 0 0 8.49-3.09 7.68 7.68 0 0 1-7.22-4.21z"
              fill="#263238"
              className="empty_svg__animable"
              style={{
                transformOrigin: "331.638px 175.223px",
              }}
            />
            <path
              d="M324.61 175.09a5.4 5.4 0 0 1-1.5 3.87c-1.32 1.37-2.94.41-3.38-1.34-.39-1.58-.17-4.19 1.55-4.91a2.44 2.44 0 0 1 3.33 2.38z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "322.089px 176.076px",
              }}
            />
            <path
              d="M330.84 244.22s1.9 49.36 6.42 78.34c3.64 23.42 19.81 78.14 19.81 78.14h10.22s-8.43-52.85-10.28-76c-4.68-58.59 7.47-71.17-4-83.37z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "349.065px 321.015px",
              }}
            />
            <path
              d="M339.38 259.83s-4.62-.8-7.32 8c1 16.67 2.71 38.79 5.2 54.73.55 3.55 1.39 7.83 2.42 12.52-1.95-28.16-.3-75.25-.3-75.25z"
              fill="#161f33"
              className="empty_svg__animable"
              style={{
                transformOrigin: "335.87px 297.446px",
              }}
            />
            <path
              d="M322.87 245.26s-8.42 54.61-7.93 77.46c.51 23.77 9.22 78 9.22 78h10.13s-1.6-52.82-.71-76.16c1-25.45 11.39-82.17 11.39-82.17z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "329.945px 321.555px",
              }}
            />
            <path
              fill="#344f79"
              d="M368.77 401.18h-13.59l-1.06-4.56 14.55.1.1 4.46z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "361.445px 398.9px",
              }}
            />
            <path
              opacity={0.2}
              d="M368.77 401.18h-13.59l-1.06-4.56 14.55.1.1 4.46z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "361.445px 398.9px",
              }}
            />
            <path
              d="M352.5 195.55c3.91.38 9.85 11.49 9.85 11.49l-9.87 7.57s-8.17-7.17-7.2-11.2c1.01-4.19 3.47-8.21 7.22-7.86z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "353.775px 205.069px",
              }}
            />
            <path
              d="M352.5 195.55c3.91.38 9.85 11.49 9.85 11.49l-9.87 7.57s-8.17-7.17-7.2-11.2c1.01-4.19 3.47-8.21 7.22-7.86z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "353.775px 205.069px",
              }}
            />
            <path
              d="M349.55 200.33a10.13 10.13 0 0 0-3.06-.34 16.91 16.91 0 0 0-1.21 3.42c-1 4 7.2 11.2 7.2 11.2l.73-.56z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "349.203px 207.296px",
              }}
            />
            <path
              d="M349.55 200.33a10.13 10.13 0 0 0-3.06-.34 16.91 16.91 0 0 0-1.21 3.42c-1 4 7.2 11.2 7.2 11.2l.73-.56z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "349.203px 207.296px",
              }}
            />
            <path
              d="M319.52 211c-2.85 7.21-5.85 14.54-8.24 21.77-.16.46-.29.9-.43 1.35l-.34 1.11a1.83 1.83 0 0 0 0 1 7.52 7.52 0 0 0 2.59 3.1 42.19 42.19 0 0 0 9.69 5.19l-.9 3.68a34.69 34.69 0 0 1-12.08-3.94 12.93 12.93 0 0 1-5.39-5.46 8.37 8.37 0 0 1-.69-4.76 5.58 5.58 0 0 1 .1-.59l.1-.42.17-.76c.12-.51.24-1 .37-1.5 1-4 2.28-7.8 3.63-11.57s2.76-7.49 4.35-11.2z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "313.215px 228.1px",
              }}
            />
            <path
              d="M313.45 200.88s-3.38 1.71 9.42 44.38l30.18-3.94c-2.12-12.22-3.12-19.79-.55-45.77a91 91 0 0 0-13 0 95.5 95.5 0 0 0-13.71 1.8c-5.79 1.29-12.34 3.53-12.34 3.53z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "333.048px 220.289px",
              }}
            />
            <path
              d="M313.45 200.88s-3.38 1.71 9.42 44.38l30.18-3.94c-2.12-12.22-3.12-19.79-.55-45.77a91 91 0 0 0-13 0 95.5 95.5 0 0 0-13.71 1.8c-5.79 1.29-12.34 3.53-12.34 3.53z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "333.048px 220.289px",
              }}
            />
            <path
              d="M353.27 239.49 355 242c.13.2-.09.44-.43.49l-31.65 4.14c-.27 0-.52-.07-.56-.24l-.62-2.67c-.05-.18.17-.37.47-.41l30.56-4a.55.55 0 0 1 .5.18z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "338.385px 242.967px",
              }}
            />
            <path
              d="M353.27 239.49 355 242c.13.2-.09.44-.43.49l-31.65 4.14c-.27 0-.52-.07-.56-.24l-.62-2.67c-.05-.18.17-.37.47-.41l30.56-4a.55.55 0 0 1 .5.18z"
              opacity={0.2}
              className="empty_svg__animable"
              style={{
                transformOrigin: "338.385px 242.967px",
              }}
            />
            <path
              d="m349.61 243.44.82-.11c.16 0 .27-.12.25-.22l-.84-3.46a.29.29 0 0 0-.34-.14l-.82.1c-.17 0-.28.12-.25.23l.84 3.45c.02.11.18.17.34.15z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "349.554px 241.471px",
              }}
            />
            <path
              d="m329.77 246 .82-.11c.16 0 .28-.12.25-.22l-.84-3.46a.31.31 0 0 0-.34-.15l-.82.11c-.16 0-.28.12-.25.22l.84 3.46c.02.15.18.21.34.15z"
              fill="#7992B3"
              className="empty_svg__animable"
              style={{
                transformOrigin: "329.715px 244.038px",
              }}
            />
            <path
              d="M314.86 215.36c.83 3.86 2 8.75 3.71 14.94l.37-15.69z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "316.9px 222.455px",
              }}
            />
            <path
              d="M314.86 215.36c.83 3.86 2 8.75 3.71 14.94l.37-15.69z"
              opacity={0.3}
              className="empty_svg__animable"
              style={{
                transformOrigin: "316.9px 222.455px",
              }}
            />
            <path
              d="M313.45 200.88c-3.75 1.51-7 14.34-7 14.34l12.9 6.28s6.23-15.69 3.44-18.75-5.02-3.6-9.34-1.87z"
              fill="#344f79"
              className="empty_svg__animable"
              style={{
                transformOrigin: "314.979px 210.702px",
              }}
            />
            <path
              d="M313.45 200.88c-3.75 1.51-7 14.34-7 14.34l12.9 6.28s6.23-15.69 3.44-18.75-5.02-3.6-9.34-1.87z"
              opacity={0.1}
              className="empty_svg__animable"
              style={{
                transformOrigin: "314.979px 210.702px",
              }}
            />
            <path
              fill="#344f79"
              d="M336.02 401.18h-13.59l-1.06-4.56 15.13.1-.48 4.46z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "328.935px 398.9px",
              }}
            />
            <path
              opacity={0.2}
              d="M336.02 401.18h-13.59l-1.06-4.56 15.13.1-.48 4.46z"
              className="empty_svg__animable"
              style={{
                transformOrigin: "328.935px 398.9px",
              }}
            />
            <path
              d="m323 243.28-1.09-.45a1.64 1.64 0 0 0-2.24 1.76l.79 5.21a1.78 1.78 0 0 0 2.36 1.42 4 4 0 0 0 1.1-.61 3 3 0 0 0 1.08-2.48l-.11-2.16a3 3 0 0 0-1.89-2.69z"
              fill="rgb(248, 162, 148)"
              className="empty_svg__animable"
              style={{
                transformOrigin: "322.329px 247.016px",
              }}
            />
          </g>
        </svg>
      </Flex>
      <Text fontSize={'36px'} fontWeight={600}>Ups!... no results found</Text>
      <Text fontSize={'24px'}>Patient {id} does not exist</Text>
    </Container>)
  }
  let patientName = `${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}`
  if (Constants.IS_SCRAMBLING_MODE) {
    patientName = `${getMockedFirstName()} ${getMockedLastName()}`
  }
  return (
    <Container id='aall' flexDirection={'row'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <Flex flexDirection={'column'} width={isExpanded ? 'calc(100% - 510px)' : '100%'} overflow={'hidden'}>
        <Flex mb={[2, 4, 4]} flexDirection={['column', 'row', 'row']}>
          {/* <Box display={['none!important', 'flex !important', 'flex !important']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
          </svg></Box> */}
                  <PatientsPhoto containerWidth={''} loading={loadingPatient} data={dataPatient} size={40} marginBottom="0" />
          <Flex flexDirection={'row'} mb={[3, 0, 0]} alignItems={'center'}>
            <Heading ml={[0, 2, 2]} mr={3}>{`${patientName}, ID ${dataPatient?.getProviderPatientById?.athenaId}`}
            </Heading>
            {!!dataPatient?.getProviderPatientById?.preferredPronouns && (
              <Text fontWeight={300} fontSize='12px' mr={3}>{`${dataPatient?.getProviderPatientById.preferredPronouns}`}</Text>
            )}
            <Box style={{ border: `1px solid #344f79`, borderRadius: '8px', padding: '0 4px', background: 'rgb(121,146, 179)' }} mr={3}>
              <Text fontWeight={400} fontSize='12px' color='white'>{`${dataPatient?.getProviderPatientById.state}`}</Text>
            </Box>
            {data && data.getProviderPatientChartAlert && (
              <Flex
                ref={chartAlertRef}
                data-event="click"
                justifyContent={'center'}
                alignItems='center'
                padding={'0px'}
                alignSelf='center'
                mr={3}
                data-tip
                data-for='chartAlertTooltip'
                style={{ backgroundColor: "#fccc00", borderBottomLeftRadius: '10px' }}>
                <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
                </svg>

              </Flex>
            )}
            <svg
              data-for='tooltipGenerateHpi' data-tip='Copy HPI to clipboard'
              onClick={() => {
                if (chartAlertRef && chartAlertRef.current) {
                  ReactTooltip.hide(chartAlertRef.current)
                }
                setIsViewHpis(true)
              }} style={{ marginRight: '16px', cursor: 'pointer' }} width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_525_2)">
                <path d="M15.75 3H12C12 1.34531 10.6547 0 9 0C7.34531 0 6 1.34531 6 3H2.25C1.00781 3 0 4.00781 0 5.25V21.75C0 22.9922 1.00781 24 2.25 24H15.75C16.9922 24 18 22.9922 18 21.75V5.25C18 4.00781 16.9922 3 15.75 3ZM9 1.875C9.62344 1.875 10.125 2.37656 10.125 3C10.125 3.62344 9.62344 4.125 9 4.125C8.37656 4.125 7.875 3.62344 7.875 3C7.875 2.37656 8.37656 1.875 9 1.875ZM13.5 16.125C13.5 16.3313 13.3313 16.5 13.125 16.5H10.5V19.125C10.5 19.3313 10.3313 19.5 10.125 19.5H7.875C7.66875 19.5 7.5 19.3313 7.5 19.125V16.5H4.875C4.66875 16.5 4.5 16.3313 4.5 16.125V13.875C4.5 13.6687 4.66875 13.5 4.875 13.5H7.5V10.875C7.5 10.6687 7.66875 10.5 7.875 10.5H10.125C10.3313 10.5 10.5 10.6687 10.5 10.875V13.5H13.125C13.3313 13.5 13.5 13.6687 13.5 13.875V16.125ZM13.5 7.125C13.5 7.33125 13.3313 7.5 13.125 7.5H4.875C4.66875 7.5 4.5 7.33125 4.5 7.125V6.375C4.5 6.16875 4.66875 6 4.875 6H13.125C13.3313 6 13.5 6.16875 13.5 6.375V7.125Z" fill="#344F7A" />
              </g>
              <defs>
                <clipPath id="clip0_525_2">
                  <rect width="18" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Flex>
        </Flex>

        <TabsContainer mb={4}>
          <Box minWidth={['1000px', '100%', '100%']} paddingBottom={['8px', 'initial', 'initial']} >
            <SwitchSelector
              onChange={(val) => {
                setselectedView(val as 'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys')
              }}
              // onChange={(val) => setselectedView(val as any)}
              name='ssSelectedView'
              options={optionsView}
              initialSelectedIndex={0}
              backgroundColor={"transparent"}
              fontColor={"#344F7A"}
              selectedFontColor={"white"}
              selectedBackgroundColor={"#344F7A"}
              forcedSelectedIndex={optionsView.findIndex(x => x.value === selectedView)}
            />
          </Box>
        </TabsContainer>

        {selectedView === 'symptoms' && (
          <Flex justifyContent={'flex-end'} mb={3}>
            <Select
              isSearchable={false}
              styles={ReactSelectStyles.programsStyles}
              options={optionsDaysBack}
              value={selectedPeriod}
              onChange={(option: IOptionsDaysBack | null, actionMeta: ActionMeta<IOptionsDaysBack>) => {
                if (!option) return
                setSelectedPeriod(option)
              }}
              components={{ Option }} />
          </Flex>
        )}
        <Flex flex={1} paddingBottom={'12px'} overflowY={selectedView === 'courses' || selectedView === 'symptoms' ? 'hidden' : 'initial'}>
          {selectedView === 'Labs' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 4, 4]} width='100%' height={'calc(100% - 30px)'}>
              <LabsAndVisits id={id} />
            </Flex>
          )}
          {selectedView === 'keyInfos' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 4, 4]} width='100%' height={'calc(100% - 30px)'}>
              <KeyInfos id={id} />
            </Flex>
          )}
          {selectedView === 'surveys' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} height={'calc(100% - 1px)'}>
                {!id ? null :
                  <Surveys id={id} />}
              </Flex>
            </>
          )}
          {selectedView === 'symptoms' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} width='100%' overflow={'hidden'}>
              <Symptoms selectedPeriod={selectedPeriod} id={id} />
            </Flex>
          )}
          {selectedView === 'courses' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0, 0, 4]} width='100%' overflow={'hidden'}>
                <LastCourses id={id} />
              </Flex>
            </>
          )}

        </Flex>

        <Flex display={['none', 'initial', 'initial']}>
          {((data || {}).getProviderPatientChartAlert || {}).notetext && (
            <ReactTooltip id='chartAlertTooltip'
              clickable={true} isCapture
              globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
              backgroundColor='#fef7d9' borderColor='#ffe781' arrowColor='#fef7d9'>
              <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                ReactTooltip.rebuild()
                ReactTooltip.hide(chartAlertRef.current)
              }}>
                <Flex>
                  <Flex flexDirection={'column'} flex={1}>
                    {((data || {}).getProviderPatientChartAlert || {}).notetext?.split('\n').map(x => {
                      return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                    })}
                  </Flex>
                  <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setIsEditAlert(true)}>Edit</Text>
                </Flex>
                <Flex flexWrap={'wrap'} mt={2}>
                  <Text mr={2} fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodifiedby}</Text>
                  <Text fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodified}</Text>
                </Flex>
              </Flex>
            </ReactTooltip>)}
        </Flex>
      </Flex>
      {!!dataPatient.getProviderPatientById.helpscoutId && (
        <MessagesWrap minWidth={'40px'} isExpanded={isExpanded}>
          <Box onClick={toggleExpanded} style={{ cursor: 'pointer', backgroundColor: '#F8A294', borderRadius: '10px 0 0 10px', marginTop: '30px', position: isExpanded ? 'relative' : 'absolute', right: 0, display: 'flex', alignSelf: 'flex-start', justifyContent: 'center', alignItems: 'center', padding: '4px' }}>
            {!isExpanded ? (
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.403 16.026L10.043 15.916C10.167 15.894 10.315 15.862 10.486 15.818C12.6 15.288 14 13.708 14 12C14 9.865 11.824 8 9 8C6.176 8 4 9.865 4 12C4 13.218 4.702 14.378 5.931 15.15L5.967 15.17L7 15.74V18.503L9.403 16.026ZM10.385 17.886L6.718 21.666C6.57942 21.809 6.40132 21.9073 6.20651 21.9484C6.0117 21.9895 5.80905 21.9715 5.62452 21.8968C5.43999 21.822 5.28197 21.6939 5.17071 21.5288C5.05945 21.3637 5.00001 21.1691 5 20.97V16.92C4.95533 16.8959 4.91131 16.8705 4.868 16.844C3.129 15.752 2 13.989 2 12C2 8.686 5.134 6 9 6C12.866 6 16 8.686 16 12C16 14.726 13.879 17.028 10.974 17.758C10.7793 17.8079 10.5828 17.8506 10.385 17.886ZM8.936 5C10.146 3.207 12.41 2 15 2C18.866 2 22 4.686 22 8C22 9.989 20.87 11.752 19.132 12.844C19.0887 12.8705 19.0447 12.8959 19 12.92V16.97C19 17.1691 18.9405 17.3637 18.8293 17.5288C18.718 17.6939 18.56 17.822 18.3755 17.8968C18.1909 17.9715 17.9883 17.9895 17.7935 17.9484C17.5987 17.9073 17.4206 17.809 17.282 17.666L15.547 15.878L16.59 14.08L17 14.503V11.74L18.033 11.17L18.069 11.15C19.299 10.378 20 9.218 20 8C20 5.865 17.824 4 15 4C13.72 4 12.574 4.383 11.703 5H8.936Z" fill="white" />
              </svg>
            ) : (
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.41 6L5 7.41L9.58 12L5 16.59L6.41 18L12.41 12L6.41 6Z" fill="white" />
                <path d="M12.9998 6L11.5898 7.41L16.1698 12L11.5898 16.59L12.9998 18L18.9998 12L12.9998 6Z" fill="white" />
              </svg>
            )}

          </Box>
          <MessagesWrapBox style={{ height: '100vh', flex: 1, padding: '12px 0 12px 0', position: 'sticky', top: 0, maxWidth: isExpanded ? '' : 0, width: isExpanded ? '' : 0, minWidth: isExpanded ? '' : 0, overflow: 'hidden' }}>
            <CommunicatorEmbedding athenaId={id} helpscoutId={dataPatient.getProviderPatientById.helpscoutId.toString()} />
          </MessagesWrapBox>
        </MessagesWrap>)}
      {!!isEditAlert && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsEditAlert(false)
          }}
          onEscapeKeydown={() => {
            setIsEditAlert(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsEditAlert(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: ''
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await appendChartAlert({
                      variables: {
                        athenaId: id,
                        noteToAdd: values.alert
                      }
                    })
                    refetchChartAlerts()
                    setIsEditAlert(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setIsEditAlert(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAppendChartAlert} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isViewHpis && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsViewHpis(false);
          }}
          onEscapeKeydown={() => {
            setIsViewHpis(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsViewHpis(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(150deg, #FDF5F2 0.64%, #D0E1F4 78.42%)',
                // padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: '95vw',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {/* <Wrapper flex={1} flexDirection={'column'} style={{ overflowY: 'auto' }}> */}
                <HpisWrapper patientId={id} onClose={() => setIsViewHpis(false)} />
              {/* </Wrapper> */}
            </Box>
            {/* <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'white',
                // padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: 'initial',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} style={{ overflowY: 'auto' }}>
                <ViewHpis athenaId={id} onClose={() => setIsViewHpis(false)} />
              </Wrapper>
            </Box> */}
          </SpecialModalBackground>
        </Modal>
      )}
      <ReactTooltip id='tooltipGenerateHpi' place="bottom" type="dark" effect="solid" />
    </Container>
  )
}


export const PatientInnerMinimized = ({ id }: { id: string }) => {
  const chartAlertRef = useRef<any>(null)
  const [isEditAlert, setIsEditAlert] = useState(false)
  const [appendChartAlert, { loading: loadingAppendChartAlert }] = useMutation<IAppendChartAlertOutput, IAppendChartAlertInput>(APPEND_CHART_ALERT)
  const { data, loading, error, refetch: refetchChartAlerts } = useQuery<IGetProviderPatientChartAlertOutput, IGetProviderPatientChartAlertInput>(GET_PATIENT_CHART_ALERTS, {
    variables: {
      id
    },
    onCompleted: async (a) => {
      await sleep(300)
      ReactTooltip.rebuild()

      if (!a || !a.getProviderPatientChartAlert || !a.getProviderPatientChartAlert.notetext) {
        ReactTooltip.hide(chartAlertRef.current)

      } else {
        ReactTooltip.show(chartAlertRef.current)
      }
    }
  })

  const [selectedView, setselectedView] = useState<'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys'>('Labs');
  const [selectedPeriod, setSelectedPeriod] = useState<IOptionsDaysBack>(optionsDaysBack.find(x => x.value === 7)!)

  const [loadPatient, { data: dataPatient, loading: loadingPatient, error: errorPatient }] = useLazyQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID)

  useEffect(() => {
    if (!id) return
    loadPatient({
      variables: {
        id
      }
    })
    setselectedView('Labs')
  }, [id])

  useEffect(() => {
    if (data && data.getProviderPatientChartAlert) {
      ReactTooltip.rebuild()

      // ReactTooltip.show(chartAlertRef.current)
    }
  }, [data, dataPatient])
  if (!id) return null
  if (loadingPatient) return (
    <Container flexDirection={'column'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }}>
      <Flex mb={4} alignItems='center' mt={`${Constants.OUTLETS_PADDING_TOP}px`}>
        <Box display={['none!important', 'flex', 'flex']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
        </svg></Box>
        <Skeleton height={36} width={250} style={{ marginLeft: '12px' }} />
      </Flex>
      <Flex flex={1} flexDirection={'column'} justifyContent='center' alignItems={'center'} >
        <LoadingMessages style={{ maxWidth: '50%' }} maxWidth='50%' />
      </Flex>
    </Container>
  )
  if (!dataPatient || !dataPatient.getProviderPatientById) {
    return (<Container flexDirection={'column'}
      justifyContent='center'
      alignItems={'center'}
      style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }} >
      <Flex mt={`${Constants.OUTLETS_PADDING_TOP}px`} style={{ position: 'relative', justifyContent: 'center' }}>
        <Flex style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Image src={doctorIcon} style={{ marginTop: '-180px', opacity: 0.5, marginRight: '-100px' }} width='80px' height='80px' />
        </Flex>
        <PatientNotFoundSvg maxWidth={'50%'} />
      </Flex>
      <Text fontSize={'36px'} fontWeight={600}>Ups!... no results found</Text>
      <Text fontSize={'24px'}>Patient {id} does not exist</Text>
    </Container>)
  }
  let patientName = `${dataPatient?.getProviderPatientById?.firstname} ${dataPatient?.getProviderPatientById?.lastname}`
  if (Constants.IS_SCRAMBLING_MODE) {
    patientName = `${getMockedFirstName()} ${getMockedLastName()}`
  }
  return (
    <Flex id='aallm' flexDirection={'row'} style={{ width: '100%', minHeight: '100%', overflow: 'hidden' }} px={2}>
      <Flex mt={`${Constants.OUTLETS_PADDING_TOP}px`} flexDirection={'column'} style={{ width: '100%' }}>
        <Flex mb={[2, 4, 4]} flexDirection={['column', 'row', 'row']}>
          <Box display={['none!important', 'flex !important', 'flex !important']}><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="#344F7A" />
          </svg></Box>

          <Flex flexDirection={'row'} mb={[3, 0, 0]} alignItems={'center'}>
            <Heading ml={[0, 2, 2]} mr={3}>{`${patientName}, ID ${dataPatient?.getProviderPatientById?.athenaId}`}
            </Heading>
            {!!dataPatient?.getProviderPatientById?.preferredPronouns && (
              <Text fontWeight={300} fontSize='12px' mr={3}>{`${dataPatient?.getProviderPatientById.preferredPronouns}`}</Text>
            )}
            <Box style={{ border: `1px solid #344f79`, borderRadius: '8px', padding: '0 4px', background: 'rgb(121,146, 179)' }} mr={3}>
              <Text fontWeight={400} fontSize='12px' color='white'>{`${dataPatient?.getProviderPatientById.state}`}</Text>
            </Box>
            {data && data.getProviderPatientChartAlert && (
              <Flex
                ref={chartAlertRef}
                data-event="click"
                justifyContent={'center'}
                alignItems='center'
                padding={'0px'}
                alignSelf='center'
                mr={3}
                data-tip
                data-for='chartAlertTooltip'
                style={{ backgroundColor: "#fccc00", borderBottomLeftRadius: '10px' }}>
                <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.00195 11.0001C7.00195 10.8688 7.02782 10.7388 7.07807 10.6174C7.12833 10.4961 7.20199 10.3859 7.29485 10.293C7.38771 10.2002 7.49794 10.1265 7.61927 10.0762C7.7406 10.026 7.87063 10.0001 8.00195 10.0001C8.13328 10.0001 8.26331 10.026 8.38464 10.0762C8.50596 10.1265 8.6162 10.2002 8.70906 10.293C8.80192 10.3859 8.87558 10.4961 8.92583 10.6174C8.97609 10.7388 9.00195 10.8688 9.00195 11.0001C9.00195 11.2653 8.8966 11.5197 8.70906 11.7072C8.52152 11.8948 8.26717 12.0001 8.00195 12.0001C7.73674 12.0001 7.48238 11.8948 7.29485 11.7072C7.10731 11.5197 7.00195 11.2653 7.00195 11.0001V11.0001ZM7.09995 4.99512C7.08664 4.86896 7.09999 4.74141 7.13915 4.62075C7.17831 4.50008 7.24241 4.389 7.32727 4.2947C7.41214 4.20041 7.51588 4.12501 7.63176 4.0734C7.74765 4.02179 7.87309 3.99512 7.99995 3.99512C8.12681 3.99512 8.25226 4.02179 8.36814 4.0734C8.48403 4.12501 8.58777 4.20041 8.67263 4.2947C8.7575 4.389 8.82159 4.50008 8.86075 4.62075C8.89991 4.74141 8.91327 4.86896 8.89995 4.99512L8.54995 8.50212C8.53573 8.63808 8.47166 8.76396 8.37009 8.85546C8.26852 8.94696 8.13666 8.99759 7.99995 8.99759C7.86325 8.99759 7.73139 8.94696 7.62982 8.85546C7.52825 8.76396 7.46417 8.63808 7.44995 8.50212L7.09995 4.99512Z" fill="black" />
                </svg>

              </Flex>
            )}
            
          </Flex>
        </Flex>
        {/* <TabsContainer mb={4}> */}
        <Flex minWidth={['1000px', '100%', '100%']} justifyContent={'flex-end'} mb={3}>
          <Select
            isSearchable={false}
            styles={ReactSelectStyles.initialStyles}
            options={optionsView as any}
            value={optionsView.find(x => x.value === selectedView)}
            onChange={(option: any) => {
              if (!option) return
              setselectedView(option.value as 'Labs' | 'keyInfos' | 'symptoms' | 'courses' | 'surveys')
            }} />

        </Flex>

        {selectedView === 'symptoms' && (
          <Select
            isSearchable={false}
            styles={ReactSelectStyles.initialStyles}
            options={optionsDaysBack}
            value={selectedPeriod}
            onChange={(option: IOptionsDaysBack | null, actionMeta: ActionMeta<IOptionsDaysBack>) => {
              if (!option) return
              setSelectedPeriod(option)
            }}
            components={{ Option }} />
        )}

        <Flex flex={1} paddingBottom={'12px'}>
          {selectedView === 'Labs' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
              <LabsAndVisits id={id} isMinimized={true} />
            </Flex>
          )}
          {selectedView === 'keyInfos' && (
            <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
              <KeyInfos id={id} isMinimized={true} />
            </Flex>
          )}
          {selectedView === 'surveys' && (
            <>
              <Flex flex={1} id='ttt' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'}>
                {!id ? null :
                  <Surveys id={id} isMinimized={true} />}
              </Flex>
            </>
          )}
          {selectedView === 'symptoms' && (
            <Flex flex={1} id='there' flexDirection={'column'} mr={[0]} width='100%' height={'100%'} overflow={'hidden'} mt={3}>
              <Symptoms selectedPeriod={selectedPeriod} id={id} isMinimized />
            </Flex>
          )}
        </Flex>

        <Flex display={['none', 'initial', 'initial']}>

          {((data || {}).getProviderPatientChartAlert || {}).notetext && (
            <ReactTooltip id='chartAlertTooltip'
              clickable={true} isCapture
              globalEventOff={"click scroll"} className='chartAlertTooltip-color' place='bottom' border={true} effect={'solid'}
              backgroundColor='#fef7d9' borderColor='#ffe781' arrowColor='#fef7d9'>
              <Flex flexDirection={'column'} minWidth={['50px', '200px', '200px']} paddingY={3} onClick={() => {
                ReactTooltip.rebuild()
                ReactTooltip.hide(chartAlertRef.current)
              }}>
                <Flex>
                  <Flex flexDirection={'column'} flex={1}>
                    {((data || {}).getProviderPatientChartAlert || {}).notetext?.split('\n').map(x => {
                      return <Text color={'#344F7A'} fontSize='14px'>⊛ {x}</Text>
                    })}
                  </Flex>
                  <Text fontWeight={300} ml={2} color={'#344F7A'} fontSize='12px' style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => setIsEditAlert(true)}>Edit</Text>
                </Flex>
                <Flex flexWrap={'wrap'} mt={2}>
                  <Text mr={2} fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodifiedby}</Text>
                  <Text fontWeight={300} color={'#344F7A'} opacity={0.7}>{((data || {}).getProviderPatientChartAlert || {}).lastmodified}</Text>
                </Flex>
              </Flex>
            </ReactTooltip>)}

        </Flex>
      </Flex>
      {!!isEditAlert && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsEditAlert(false)
          }}
          onEscapeKeydown={() => {
            setIsEditAlert(false)
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsEditAlert(false)
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Flex flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Formik
                  initialValues={{
                    alert: ''
                  }}
                  isInitialValid={() => {
                    return true
                  }}
                  onSubmit={async (values) => {
                    await appendChartAlert({
                      variables: {
                        athenaId: id,
                        noteToAdd: values.alert
                      }
                    })
                    refetchChartAlerts()
                    setIsEditAlert(false)
                  }}
                >
                  {({ touched, errors, isValid, values, submitForm }) => {
                    return (
                      <>
                        <Form>
                          <Heading textAlign={'center'} mb={4}>Add New Sticky Note Entry</Heading>
                          <FormField mb={3} error={touched.alert && errors.alert}>
                            <TextArea style={{ minHeight: '200px', maxHeight: '200px' }} name="alert" id="input_name" />
                          </FormField>
                          <Flex alignItems="center" flexDirection="row" justifyContent={'center'}>
                            <Button variant="outline" width={'100px'} mr={3} type="button" id="btn_login" onClick={() => setIsEditAlert(false)}>
                              Cancel
                            </Button>
                            <Button disabled={!isValid || !!loadingAppendChartAlert} variant="primary" width={'100px'} type="button" id="btn_login" onClick={submitForm}>
                              Save
                            </Button>
                          </Flex>
                        </Form>

                      </>
                    );
                  }}
                </Formik>
              </Flex>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      
    </Flex>
  )
}

const Patient = () => {
  let { id } = useParams();

  if (!id) return null

  return (
    <PatientInner id={id} />
  )
}

export const PatientEmbed: React.FC<{
  athenaId: string
}> = ({ athenaId }) => {
  return (
    <PatientInnerMinimized id={athenaId} />
  )
}

export default Patient